import { Box, Button, ITheme, IconButton, Modal, Typography, useTheme } from '@mui/material';
import React from 'react';
import CloseIcon from '@mui/icons-material/Close';

export interface IConfirmationFormActionProps {
    type: 'primary' | 'secondary';
    title: string;
    action: (e: React.MouseEvent) => void;
}

export interface IConfirmationFormProps {
    title: string;
    content: string;
    confirmAction: IConfirmationFormActionProps[];
    onClose: (e: React.MouseEvent) => void;
}

const ConfirmationForm: React.FC<IConfirmationFormProps> = ({ title, content, confirmAction, onClose }) => {
    const theme = useTheme() as ITheme;

    return <Modal
        onClose={onClose}
        open={true}>
        <Box display={"flex"} flexDirection={"column"} alignItems={"center"} gap={"34px"} width={"746px"} bgcolor={theme.palette.background.default} padding={"38px 39px"} borderRadius={"8px"} sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
            <Box display={"flex"} justifyContent={"flex-end"} width={"100%"}>
                <IconButton onClick={onClose}>
                    <CloseIcon sx={{ color: theme.palette.primary.dark }} />
                </IconButton>
            </Box>
            <Typography fontSize={"18px"} fontWeight={"700"} lineHeight={"20px"}>{title}</Typography>
            <Typography fontSize={"18px"} fontWeight={"500"} lineHeight={"20px"}>{content}</Typography>
            <Box display={"flex"} gap={"18px"} width={"100%"} justifyContent={"center"}>
                {confirmAction.map((action) => (
                    <Button variant={action.type === "primary" ? 'contained' : 'outlined'} key={`deletebtn-${action.title}`} onClick={action.action} sx={{ textTransform: "none", width: "284px"}}>{action.title}</Button>
                ))}
            </Box>
        </Box>
    </Modal>;
}

export default ConfirmationForm;